@let check = checks();
<div class="flex-column pt-2">
    <div [formGroup]="form" class="grid-6col input-grid-gaps">
        <app-text-input
            id="name"
            label="user.createUser.name"
            [form]="form"
            class="fr-3"
        ></app-text-input>
        <app-text-input
            id="surname"
            label="user.createUser.surname"
            [form]="form"
            class="fr-3"
        ></app-text-input>
        <app-email-input
            id="email"
            autocorrect="off" spellcheck="false"
            label="user.createUser.email"
            [form]="form"
            class="fr-3"
        ></app-email-input>
        <app-password-input
            id="password"
            label="user.createUser.password"
            [form]="form"
            class="fr-2"
        ></app-password-input>
        <app-select-input
            id="sex"
            label="user.common.sex.label"
            [form]="form"
            class="fr-1"
            [staticOptions]="sexOptions"
            [showClear]="false"
        ></app-select-input>
        <div class="fr-3">
            <app-select-user-group [form]="form"></app-select-user-group>
        </div>
        <div class="fr-3">
            <app-select-user-rule [form]="form"></app-select-user-rule>
        </div>
        @if (withServices()) {
            <div class="fr-3">
                <app-cascade-contract-select-input
                    [form]="form"
                    (contractSelected)="onContractSelected($event)"
                />
            </div>
        }
        <div class="fr-3">
            <app-date-input [form]="form" timeType="startOfDay" id="dateFrom"></app-date-input>
        </div>

        @if (withServices()) {
            <div class="fr-4">
                <app-employment-type-select-input [form]="form"/>
            </div>
            <div class="fr-2"></div>

            @if (workplaces.length) {
                <div class="fr-2">
                    <app-select-input
                        id="workplace"
                        label="user.createUser.workplace"
                        [form]="form"
                        class="fr-2"
                        valueKey="id"
                        [staticOptions]="workplaces"
                        [showClear]="false"
                    ></app-select-input>
                </div>
            }

            @if (workloadVisible) {
                <div class="fr-2">
                    <app-select-input
                        id="workloadType"
                        label="user.createUser.workloadType"
                        [form]="form"
                        [staticOptions]="workloadTypeToEnumOptions"
                        [showClear]="false"
                    ></app-select-input>
                </div>
                <div class="fr-2">
                    <app-number-input
                        [form]="form"
                        id="workloadSize"
                        [minFractionDigits]="1"
                        [maxFractionDigits]="5"
                        label="user.createUser.workloadSize"
                    ></app-number-input>
                </div>
            }

            @if (scopeOfWorkVisible) {
                <div class="fr-2">
                    <app-number-input
                        [form]="form"
                        id="scopeOfWork"
                        label="user.createUser.scopeOfWork"
                    ></app-number-input>
                </div>
            }
        }
    </div>

    @if (check.toEmploy) {
        <app-warn-float-message message="user.messages.toEmploy"></app-warn-float-message>
    } @else if (check.toAssign) {
        <app-warn-float-message message="user.messages.alreadyExists"></app-warn-float-message>
    } @else if (check.exists) {
        <app-error-float-message message="user.messages.alreadyAssigned"></app-error-float-message>
    }
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        [primaryButtonDisability]="check.exists && !check.toAssign && !check.toEmploy"
        [primaryButtonLoading]="loading"
        (primaryClickEvent)="saveUser()"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
